import { useEffect, useState } from "react";
import Link from "next/link";
import { PropertyDataV2 } from "commonModule/services/common";
import { PropertySkeletonForListingPage } from "components/shared/skeletons/PropertySkeletonForListingPage";
import TravelAgentSearchCard from "components/travel-agent/TravelAgentSearchCard";
import { NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE } from "constant";
import { findMostCommonCity } from "utils/property-utils";
import { createSearchURL, ensembleCityStateCountry } from "utils/url";
const PropertyWindow = ({
  propertyData,
  isTheseNearByProperties
}: {
  propertyData?: PropertyDataV2[];
  isTheseNearByProperties: boolean;
}) => {
  const [urlProperty, setUrlProperty] = useState<PropertyDataV2 | undefined>(propertyData?.[0]);
  useEffect(() => {
    if (propertyData) {
      const data = isTheseNearByProperties && propertyData && propertyData.length > 0 ? findMostCommonCity(propertyData) : propertyData[0];
      setUrlProperty(data);
    }
  }, [propertyData, isTheseNearByProperties]);
  return <>
      <div className='grid w-full grid-cols-[repeat(auto-fill,_minmax(260px,_1fr))] gap-8 px-4 pt-4 md:px-8 md:pt-16 lg:pt-8'>
        {propertyData && propertyData.length > 0 && propertyData.map((property, index) => <TravelAgentSearchCard key={property._id} property={property} propertyIndex={index} />)}
        {propertyData === null ? <></> : propertyData !== null && !propertyData && Array(NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE).fill(1).map((e, i) => <div key={i} className='pb-10'>
                <PropertySkeletonForListingPage />
              </div>)}
      </div>
      {isTheseNearByProperties && urlProperty && propertyData && propertyData?.length > 0 && <div className='my-4 px-4 md:hidden md:px-6'>
            <p className='text-sm font-medium leading-6 text-secondary1000 underline'>
              <Link href={`/vacation-rentals/${createSearchURL(ensembleCityStateCountry({
          city: urlProperty?.city,
          state: urlProperty?.state,
          country: urlProperty?.country
        }))}`} target='_blank' rel='noreferrer' className='  cursor-pointer text-sm font-medium leading-6 text-secondary1000 underline md:hidden'>
                View all properties in{" "}
                {urlProperty?.city || urlProperty?.state || urlProperty?.country}
              </Link>
            </p>
          </div>}
    </>;
};
export default PropertyWindow;